export const datesDefault = [
  { label: "day" },
  { label: "week" },
  { label: "month" },
];
